// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8685":"1a7b8fa4","9921":"707da4f9"}[chunkId] + ".chunk.css";
};